<template>
	<div class="table-notifications">

		<div 
			v-if="notificationData && notificationData.length > 0"
			class="the-table" 
			>
			<div class="headers">
				<div class="row">
					<span>Category</span>
					<span>Case</span>
					<span>Date/time</span>
					<span class="user-count">Receiving Users</span>
					<span></span>
				</div>
			</div>
			<div class="table">
				<template 
					v-for="(notification, index) in notificationData"
					>
					<div 
						v-if="notification.category !== 'form-submission'"
						class="row"
						:key="index"
						>
							
						<span>{{ notification.category }}</span>

						<span>
							<Link :href="`/cases/${notification.project.hashid}`">
								{{ notification.project.enquiry_number ? `E/N: ${notification.project.enquiry_number}` : `ID: ${notification.project.hashid}` }}
							</Link>
						</span>

						<span>{{ niceDate(notification.created_at) }}</span>

						<span class="user-count">
							<div
								@click="toggleUsersModal(notification.users)" 
								class="number-bubble"
								>
								{{ notification.users.length }}
							</div>
						</span>

						<span>
							<i 
								@click="toggleNotificationDetailsModal(notification)"
								class="fal fa-eye"
								/>
						</span>

					</div>
				</template>
			</div>
		</div>
		<Placeholder v-else>
			No notifications found...
		</Placeholder>


		<Modal 
			v-if="showUsersModal"
			title="Notification Received by..."
			:wider="true"
			@close="toggleUsersModal"
			>

			<template 
				v-if="usersModalData && usersModalData.length > 0"
				>
				<ul class="users-modal-list">
					<li class="headers">
						<span>Name</span>
						<span>To</span>
						<span>Method</span>
						<span>User Type</span>
					</li>
					<li
						v-for="(user, index) in usersModalData"
						:key="index"
						>
						<span>{{ user.name }}</span>
						<span>{{ ['email'].includes(user.contact_pref) ? user.email : user.phone }}</span>
						<span>{{ translateContactPref(user.contact_pref) }}</span>
						<span>{{ niceRoleName(user.user_type) }}{{ user.tag != null ? ` - ${user.tag}` : '' }}</span>
					</li>
				</ul>
			</template>

			<Placeholder v-else>
				No data found...
			</Placeholder>
		
		</Modal>

		<Modal
			v-if="showNotificationDetailsModal"
			title="Notification Details"
			@close="toggleNotificationDetailsModal"
			>
			<div 
				v-if="notificationDetailsModalData"
				class="notification-details-modal"
				>
				
				<div class="info-row">
					<label>Category:</label> 
					{{ notificationDetailsModalData.category }}
				</div>
				<div class="info-row">
					<label>Case:</label> 
					<Link :href="`/cases/${notificationDetailsModalData.project.hashid}`">
						{{ notificationDetailsModalData.project.enquiry_number ? notificationDetailsModalData.project.enquiry_number : notificationDetailsModalData.project.hashid }}
					</Link>
				</div>
				<div class="info-row">
					<label>Date/time:</label> 
					{{ niceDate(notificationDetailsModalData.created_at) }}
				</div>
				<div class="info-row">
					<label>Message:</label> 
					{{ notificationDetailsModalData.message }}
				</div>

				<template v-if="notificationDetailsModalData.form">
					<div class="info-row">
						<label>Form name:</label> 
						{{ notificationDetailsModalData.form.name }}
					</div>
					<div class="info-row">
						<label>Form due date:</label> 
						{{ niceDate(notificationDetailsModalData.form_due_date, true) }}
					</div>
				</template>

			</div>

			<Placeholder v-else>
				No data found...
			</Placeholder>
		</Modal>

	</div>
</template>

<script>
import moment from 'moment'
import { Link } from '@inertiajs/inertia-vue3'

import Modal from '@/Components/Modal'
import Placeholder from '@/Components/Placeholder'

export default {
	components: {
		Link,
		Modal,
		Placeholder
	},
	props: {
		notificationData: Object,
	},
	data: () => {
		return {
			showUsersModal: false,
			showNotificationDetailsModal: false,
			usersModalData: false,
			notificationDetailsModalData: false,
		}
	},
	mounted(){
		// console.log('users', this.notificationData)
	},
	methods: {
		niceDate(dateString, justDate = false){
			let theDate = new Date(dateString)
			if(justDate){
				return moment(theDate).format('DD/MM/YYYY')
			}else{
				return moment(theDate).format('DD/MM/YYYY HH:mm')
			}
		},
		toggleUsersModal(data){
			if(this.showUsersModal){
				this.usersModalData = false
			}
			this.showUsersModal = !this.showUsersModal
			this.usersModalData = data
		},
		toggleNotificationDetailsModal(data){
			if(this.showNotificationDetailsModal){
				this.notificationDetailsModalData = false
			}
			this.showNotificationDetailsModal = !this.showNotificationDetailsModal
			this.notificationDetailsModalData = data
		},
		niceRoleName(type){
			switch(type){
				case 'admin':
					return 'Super Admin'
					break
				case 'user':
					return 'User'
					break
			}
		},
		translateContactPref(pref){
			switch(pref){
				case 'email':
					return 'Email'
					break
				default:
					return 'Do not notify'
			}
		}
	},
}
</script>

<style lang="sass" scoped>

.table-notifications
	width: 100%
	display: flex
	flex-direction: column

	.the-table
		.row
			display: grid
			grid-template-columns: 1fr 1fr 1fr 0.5fr 40px

			span
				display: flex
				align-items: center

				a
					text-decoration: underline
					color: #00d
					transition: all 300ms

					&:hover
						opacity: 0.7

				&:last-child
					justify-content: flex-end

				&.user-count
					justify-content: center
					text-align: center

					.number-bubble
						padding: 4px 12px
						background-color: #888
						color: #fff
						font-weight: 700
						font-size: 18px
						border-radius: 10px
						cursor: pointer
						transition: all 300ms

						&:hover
							background-color: #ff9000

		@media (max-width: 900px)
			overflow-x: auto
			
			.row
				display: flex

				span
					min-width: 130px


		.headers
			font-size: 18px
			font-weight: 700
			font-family: 'Roboto Condensed', sans-serif
			color: #252525
			line-height: 1.1
			margin-bottom: 10px

			.row
				padding: 0 20px


		.table
			width: 100%
			background-color: #fff
			border-radius: 8px
			box-shadow: 0 1px 3px rgba(#000, 0.12)
			padding: 0 20px

			.row
				font-size: 14px
				font-weight: 400
				font-family: 'Roboto', sans-serif
				color: #252525
				line-height: 1.1
				height: 60px
				border-bottom: 1px solid #d0d0d0
				align-items: center

				&:last-child
					border-bottom: none

				.fal
					font-size: 22px
					color: #252525
					margin-left: 20px
					transition: all 300ms
					cursor: pointer

					&:hover
						opacity: 0.7


	.no-data
		width: 100%
		background-color: rgba(#fff, 0.2)
		border-radius: 8px
		box-shadow: 0 1px 3px rgba(#000, 0.12)
		padding: 0 20px
		height: 60px
		display: flex
		justify-content: center
		align-items: center

	.users-modal-list
		width: 100%
		display: flex
		flex-direction: column

		li
			display: grid
			grid-template-columns: 1fr 1.2fr 0.8fr 1fr
			border-bottom: 1px solid #f0f0f0
			padding: 10px 0
			font-size: 15px

			&.headers
				font-size: 18px
				font-weight: 700
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				line-height: 1.1

				span
					display: flex
					align-items: center

			span
				display: flex
				align-items: center

	.notification-details-modal
		.info-row
			padding: 15px 0
			border-bottom: 1px solid #f0f0f0
			display: flex
			flex-direction: column
			font-size: 15px

			label
				display: flex
				margin-bottom: 10px
				font-size: 18px
				font-weight: 700
				font-family: 'Roboto Condensed', sans-serif
				color: #252525
				line-height: 1.1

			&:last-child
				border-bottom: none

</style>
